<template>
  <div id="login">
    <div class="container">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="60px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="name">
          <el-input
            type="text"
            v-model="ruleForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" @keyup.enter.native="login()" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <div class="findPass">
          <span @click="goFind">找回密码</span>
        </div>
        <el-form-item>
          <el-button type="primary" @click="login()">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/login/login"; //按需引入请求接口
export default {
  data() {
    var nameCheck = (rule, value, callback) => {
      //登录校验
      if (!value) {
        return callback(new Error("登录名不能为空！"));
      } else {
        callback();
      }
    };
    var passwordCheck = (rule, value, callback) => {
      //登录密码校验
      if (!value) {
        return callback(new Error("密码不能为空！"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        //表单数据--登录
        name: "",
        password: "",
      },
      rules: {
        name: [{ validator: nameCheck, trigger: ["blur", "change"] }],
        password: [{ validator: passwordCheck, trigger: ["blur", "change"] }],
      },
    };
  },
  created() {},
  mounted() {
    if (process.env.NODE_ENV !== 'production') {
      this.ruleForm.name='admin'
      this.ruleForm.password='Hbgs123!@'
    }
  },
  methods: {
    login() {
      //发起登录
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          let res = await login({
            userName: this.ruleForm.name,
            passWord: this.ruleForm.password,
          });
          if (res.code == 200) {
            this.$message.success("登录成功！");
            var millisecond = new Date().getTime();
            var expiresTime = new Date(millisecond + 60 * 1000 * 60); //一个小时过期
            this.$cookie.set("token", 11, { expires: expiresTime });
            this.$router.push("/homeManage");
          } else if (res.code == 250) {
            this.$message.error(res.msg);
          }
        }
      });
    },
    goFind() {
      //跳转至找回密码页面
      this.$emit("toogle", "findPassword");
    },
  },
};
</script>

<style lang="less" scoped>
#login {
  height: 100%;
}
.findPass {
  font-size: 13px;
  text-align: right;
}
</style>